<template>
  <transition name="component-fade">
    <UiButton
      theme="primary"
      size="medium"
      :disabled="nextStep == ''"
      @click.native="goToNextStep"
    >
      {{ $t("global.next") }}
    </UiButton>
  </transition>
</template>

<script>
import UiButton from "./Ui/Button/index.vue";
export default {
  components: {
    UiButton
  },
  props: {
    nextStep: {
      type: String,
      required: true
    }
  },
  methods: {
    goToNextStep() {
      this.$router.push({ name: this.nextStep });
    }
  }
};
</script>
